/**
 * application_loaded.ts
 *
 * body末尾で読み込まれ、ページ読み込み完了後の処理を行います。
 *
 * 注意: notify.jsはUMDモジュールのため、side-effect importで
 * グローバルのwindow.jQueryを参照しfactory(jQuery)が評価されます。
 */

// notify.js UMD側のブラウザグローバル分岐でfactory(jQuery)が自動評価される
import '@/javascripts/notify-setup';

import { initCustomLinkMenu } from '@/javascripts/custom_link_menu';
import { initGuidanceModal } from '@/javascripts/guidance_modal';
import { initGuidanceModalPreviewListener } from '@/javascripts/guidance_modal_preview_listener';
import { initAdminMessageNotificationModal } from '@/javascripts/admin_message_notification_modal';

// Share URL Copy
document.addEventListener('DOMContentLoaded', () => {
  const $ = (window as typeof window & { jQuery?: JQueryStatic }).jQuery;
  if (!$) return;

  $('.js-share_copy').on('click', async function () {
    // data-target 持ちの要素は copy_target.js の CopyTarget が担当するため除外(非同期writeTextが後勝ちで上書きするのを防ぐ)
    if (this.dataset.target) return;
    try {
      await navigator.clipboard.writeText(`${location.origin}${location.pathname}`);
      ($ as JQueryStatic & { notify: (msg: string, opts: object) => void }).notify('コピーしました', { position: 'top center', className: 'success' });
    } catch (err) {
      console.error('クリップボードへのコピーに失敗しました:', err);
      ($ as JQueryStatic & { notify: (msg: string, opts: object) => void }).notify('コピーに失敗しました', { position: 'top center', className: 'error' });
    }
  });
});

initCustomLinkMenu();
initGuidanceModal();
initGuidanceModalPreviewListener();
initAdminMessageNotificationModal();
